// Utils
import createKeyIndex from '../../../../common/utils/lib/createKeyIndex';

// Constants
import { CARD_TYPE } from '../../../../common/cards/cardConstants';
import { LINE_TYPE } from '../../../../common/lines/lineConstants';
import { BOARD_TYPE } from '../../../../common/boards/boardConstants';
import { COLUMN_TYPE } from '../../../../common/columns/columnConstants';
import { TASK_LIST_TYPE } from '../../../../common/taskLists/taskListConstants';
import { COMMENT_THREAD_TYPE } from '../../../../common/comments/commentConstants';
import { SKETCH_TYPE } from '../../../../common/drawings/sketches/sketchConstants';
import { COLOR_SWATCH_TYPE } from '../../../../common/colorSwatches/colorSwatchesConstants';
import { LINK_ELEMENT_LINK_TYPES, LINK_TYPE } from '../../../../common/links/linkConstants';
import { IMAGE_TYPE } from '../../../../common/images/imageConstants';
import { FILE_TYPE } from '../../../../common/files/fileConstants';
import { ANNOTATION_TYPE } from '../../../../common/drawings/annotations/annotationConstants';
import { DOCUMENT_TYPE } from '../../../../common/documents/documentConstants';
import { TABLE_TYPE } from '../../../../common/table/tableConstants';
import { AI_ASSISTANT_TOOL_TYPE } from '../../../../common/ai/aiToolConstants';

export const AUDIO_TOOL_KEY = `${LINK_TYPE}-${LINK_ELEMENT_LINK_TYPES.AUDIO}`;
export const MAP_TOOL_KEY = `${LINK_TYPE}-${LINK_ELEMENT_LINK_TYPES.MAP}`;
export const VIDEO_TOOL_KEY = `${LINK_TYPE}-${LINK_ELEMENT_LINK_TYPES.VIDEO}`;
export const HEADER_TOOL_KEY = `${CARD_TYPE}-HEADER`;
export const SEPARATOR_TOOL_KEY = 'TOOL_SEPARATOR';
export const MORE_TOOL = 'MORE_TOOL';

export const DEFAULT_TOOLS_ORDER = [
    CARD_TYPE,
    LINK_TYPE,
    TASK_LIST_TYPE,
    LINE_TYPE,
    BOARD_TYPE,
    COLUMN_TYPE,
    COMMENT_THREAD_TYPE,
    SKETCH_TYPE,
    COLOR_SWATCH_TYPE,
    DOCUMENT_TYPE,
    AUDIO_TOOL_KEY,
    MAP_TOOL_KEY,
    VIDEO_TOOL_KEY,
    HEADER_TOOL_KEY,
    // divider
    MORE_TOOL,
    SEPARATOR_TOOL_KEY,
    // secondary tools
    IMAGE_TYPE,
    FILE_TYPE,
    ANNOTATION_TYPE,
];

// order in which tools should be collapsed from the toolbar
// In descending order of priority — the first tool in the array will be the first to be collapsed
export const COLLAPSE_ORDER = [
    MAP_TOOL_KEY,
    AUDIO_TOOL_KEY,
    VIDEO_TOOL_KEY,
    HEADER_TOOL_KEY,
    SKETCH_TYPE,
    LINE_TYPE,
    DOCUMENT_TYPE,
    COLOR_SWATCH_TYPE,
    FILE_TYPE,
    TABLE_TYPE,
    COMMENT_THREAD_TYPE,
    LINK_TYPE,
    IMAGE_TYPE,
    AI_ASSISTANT_TOOL_TYPE,
    ANNOTATION_TYPE,
    TASK_LIST_TYPE,
    COLUMN_TYPE,
    BOARD_TYPE,
];

// touch collapse order — same as COLLAPSE_ORDER, but FILE_TYPE will collapse later
export const COLLAPSE_ORDER_TOUCH = [
    MAP_TOOL_KEY,
    AUDIO_TOOL_KEY,
    VIDEO_TOOL_KEY,
    HEADER_TOOL_KEY,
    SKETCH_TYPE,
    LINE_TYPE,
    DOCUMENT_TYPE,
    COLOR_SWATCH_TYPE,
    TABLE_TYPE,
    COMMENT_THREAD_TYPE,
    LINK_TYPE,
    IMAGE_TYPE,
    AI_ASSISTANT_TOOL_TYPE,
    ANNOTATION_TYPE,
    FILE_TYPE,
    TASK_LIST_TYPE,
    COLUMN_TYPE,
    BOARD_TYPE,
];

const createToolMap = (toolsArray: string[]) => createKeyIndex([...toolsArray]);

export const DEFAULT_PRIMARY_TOOLS = createToolMap([
    CARD_TYPE,
    LINK_TYPE,
    TASK_LIST_TYPE,
    LINE_TYPE,
    BOARD_TYPE,
    COLUMN_TYPE,
    TABLE_TYPE,
    COMMENT_THREAD_TYPE,
    // secondary tools
    IMAGE_TYPE,
    FILE_TYPE,
    ANNOTATION_TYPE,
    AI_ASSISTANT_TOOL_TYPE,
]);

export const DEFAULT_PRIMARY_TOOLS_TOUCH = createToolMap([
    CARD_TYPE,
    LINK_TYPE,
    TASK_LIST_TYPE,
    BOARD_TYPE,
    COLUMN_TYPE,
    TABLE_TYPE,
    COMMENT_THREAD_TYPE,
    SKETCH_TYPE,
    // secondary tools
    IMAGE_TYPE,
    FILE_TYPE,
    ANNOTATION_TYPE,
]);
